import styled, { css } from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  height: 50px;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${ColorSF2.paleBlue};
  padding: 0 0 0 10px;
  position: relative;
`;
export const Contents = styled.div`
  height: 50px;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const ContentsTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
`;
export const SettingsImageWrapper = styled.div`
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  background: ${props => props.isShow && ColorSF2.skyBlue};
`;
export const Settings = styled.div`
  width: 240px;
  position: absolute;
  top: 50px;
  right: 0px;
  background: ${ColorSF2.white};
  box-shadow: 0px 3px 6px ${ColorSF2.transparentShadow};
  opacity: 1;
  z-index: 3;
`;
export const SettingsItem = styled.div`
  display: flex;
  height: 50px;
  padding: 0px 14px;
  align-items: center;
  &:not(:last-child) {
    border-bottom: 1px solid ${ColorSF2.mediumGray};
  }
  ${props =>
    !props.isEnabled &&
    css`
      pointer-events: none;
      opacity: 0.4;
    `}
`;

export const ButtonImage = styled.img`
  width: 20px;
  height: 20px;
  opacity: ${props => (props.isDisabled ? '0.5' : '1')};
  pointer-events: ${props => (props.isDisabled ? 'none' : 'auto')};
`;
